<template>
  <div class="ts-p-6">
    <label
      class="col-form-label ts-mb-3 ts-font-bold ts-w-full ts-px-2 bg-success ts-flex ts-justify-items-center ts-items-center"
      style="height: 45px;">
      <i class="fa fa-id-card fa-fw fa-lg ts-pb-1" style="color: white;"></i>
      <h4 style="margin: 0 !important;color: white;" class="ts-pl-2">{{ $t('restaurantSale.memberCard') }}</h4>
    </label>
    <div class="ts-border-t ts-border-gray-300 ts-pt-4">
      <input v-model.trim="search" ref="search" type="text" :placeholder="$t('restaurantSale.searchMemberCard')"
        class="form-control" />
      <div class="ts-my-3">
        <div class="pos pos-counter">
          <div class="pos-counter-body">
            <div class="pos-counter-content">
              <vue-custom-scrollbar class="pos-counter-content-container">
                <ts-loading-banner :loading="false">
                  <div class="table-row">
                    <MemberCard v-for="(table, index) in customerMemberCards" :key="index" :table="table"
                      :selected="tableSelected.ref_customer_member_card_id == table.customer_member_card_id"
                      @click="onTableSelected(table)" />
                  </div>
                </ts-loading-banner>
              </vue-custom-scrollbar>
            </div>
          </div>
        </div>
        <div class="ts-py-1">
          <i>
            <span class="ts-text-xs">
              {{ $t('restaurantSale.selectOrScanKey') }}
            </span>
          </i>
        </div>
      </div>
      <div class="btn-row ts-space-x-2 ts-text-right ts-border-t ts-border-gray-300 ts-pt-4">
        <ts-button @click.prevent="onBack()"><i class="fa fa-arrow-left fa-fw fa-lg"></i>
          {{ $t('restaurantSale.back') }}</ts-button>
        <ts-button :disabled="!tableSelected.ref_customer_member_card_id" class="btn-success"
          @click.prevent="onCheckOut()"><i class="fa fa-check fa-fw fa-lg"></i>
          {{ $t('submit') }}</ts-button>
      </div>
    </div>
  </div>
</template>

<script>
import MemberCard from './MemberCheckOutTableCard.vue'

export default {
  name: 'memeber',
  props: ['tableSelected'],
  components: {
    MemberCard
  },
  data() {
    return {
      loading: false,
      search: '',
      model: {}
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    customerMemberCards() {
      return this.$store.state.restaurantSale.counterCheckout.customer_member_cards.filter(
        ei =>
          this.search
            .split(' ')
            .every(s =>
              ei.customer_name.toLowerCase().includes(s.toLowerCase())
            ) ||
          this.search
            .split(' ')
            .every(s =>
              ei.contact_number.toLowerCase().includes(s.toLowerCase())
            ) ||
          this.search
            .split(' ')
            .every(s =>
              ei.serial_card.toLowerCase().includes(s.toLowerCase())
            )
      )
        .slice(0, 20)
    },
  },
  methods: {
    onTableSelected(row) {
      if (this.$store.state.restaurantSale.counterCheckout.tables.find(el => el.ref_customer_member_card_id == row.customer_member_card_id)) {
        this.$notification['warning']({
          message: 'Check-in',
          description: 'Member Card is already actived!',
          placement: 'bottomRight'
        })
        return
      }
      if (this.tableSelected.ref_customer_member_card_id == row.customer_member_card_id) {
        this.tableSelected.ref_customer_member_card_id = null
        this.tableSelected.customer_id = null
      } else {
        this.tableSelected.ref_customer_member_card_id = row.customer_member_card_id
        this.tableSelected.customer_id = row.customer_id
      }
    },
    onBack() {
      this.tableSelected.ref_customer_member_card_id = null
      this.tableSelected.customer_id = null
      this.$emit('cancel')
    },
    onCheckOut() {
      this.$emit('onTableSelected', this.tableSelected)
    }
  },
  watch: {
    validate: function (error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>

<style scoped lang="scss">
.max-h {
  min-height: 45vh;
  max-height: 45vh;
  overflow-y: scroll;
}

.pos-counter {
  padding-top: 0px;
  height: 400px !important;

  @media (max-width: 75em) {
    height: 400px !important;
  }

  @media (max-width: 54em) {
    height: 400px !important;
  }

  @media (max-width: 37.5em) {
    height: 350px !important;
  }
}


.form-control {
  height: 32px;
}

table {
  width: 100%;
}

table thead tr {
  border-width: 1px;
  z-index: 3;
  position: sticky;
  top: 0;
  /* Don't forget this, required for the stickiness */
}

table thead tr th {
  white-space: nowrap;
  background-color: #edf2f7;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

table tbody tr {
  cursor: pointer;
  border-width: 1px;
}

table tbody tr:hover {
  background-color: #e2e8f0;
}

table tbody tr td {
  white-space: nowrap;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  border-right-width: 1px;
  height: 40px;
}
</style>
